import { z } from "zod";

/**
 * AlterarCentroCustoSchema
 */

export const AlterarCentroCustoSchema = z.object({
  centroCusto: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
});

/**
 * AlterarCentroCustoForm
 */

export type AlterarCentroCustoForm = z.infer<typeof AlterarCentroCustoSchema>;